<template>
  <Layout>
    <div class="card shadow-lg">
      <div class="card-body">
        <form-wizard @on-complete="onComplete()" shape="pill" back-button-text="Previous" next-button-text="Next" finish-button-text="Submit" color="#2e0b0b">
          <tab-content title="Student details" icon="mdi mdi-account">
            <div class="row">
              <b-form-group class="col-md-4 mb-1" label="Student Name">
                <b-form-input v-model="studentname" type="text" placeholder="Enter Student Name"></b-form-input>
              </b-form-group>
              <div class="col-md-4 mb-1">
                <label>Gender</label>
                <select class="form-control" v-model="gender"><option>Female</option><option>Male</option></select>
              </div>
              <b-form-group class="col-md-4 mb-1" label="Telephone">
                <b-form-input v-model="telephone" type="number" placeholder="Enter Telephone"></b-form-input>
              </b-form-group>
              <b-form-group class="col-md-4 mb-1" label="Date of Birth">
                <b-form-input v-model="dob" type="date" :max="currentdate" placeholder="Enter Date of Birth"></b-form-input>
              </b-form-group>
              <b-form-group class="col-md-4 mb-1" label="Nationality">
                <v-select :options="countries" placeholder="Enter Nationality" v-model="nationality" label="name" :reduce="nationality => nationality.id"></v-select>
              </b-form-group>
              <b-form-group class="col-md-4 mb-1" label="Address">
                <b-form-input v-model="address" type="text" placeholder="Enter Address"></b-form-input>
              </b-form-group>
              <div class="col-md-4 mb-1">
                <label>Religion</label>
                <select class="form-control" v-model="religion">
                  <option value="Christian">Christian</option>
                  <option value="Moslem">Moslem</option>
                </select>
              </div>
              <b-form-group class="col-md-4 mb-1" label="Previous School">
                <b-form-input v-model="previousschool" type="text" placeholder="Enter Previous School"></b-form-input>
              </b-form-group> 
              <b-form-group class="col-md-4 mb-1" label="Registration Date">
                <b-form-input v-model="reg_date" type="date"></b-form-input>
              </b-form-group>
            </div>
          </tab-content>
          <tab-content title="Guardian Details" icon="fas fa-user-tie" >
              <b-button class="btn btn-success mb-3" @click="AddformData"><i class="mdi mdi-plus"></i> Add Guardian</b-button>
              <form class="repeater mb-5">
              <div>
                  <div v-for="(parent, index) in parents" :key="parent.id" class="row" >
                  <div class="mb-2 col-md-3">
                      <label>Name</label>
                      <input v-model="parent.name" type="text" class="form-control" />
                  </div>
                  <div class="mb-2 col-md-2">
                      <label>Gender</label>
                      <select class="form-control" v-model="parent.gender">
                          <option>Female</option><option>Male</option>
                      </select>
                  </div>
                  <div class="mb-2 col-md-3">
                      <label>Telephone</label>
                      <input v-model="parent.telephone" type="number" class="form-control" />
                  </div>
                  <div class="mb-2 col-md-3">
                      <label>Address</label>
                      <input v-model="parent.address" type="text" class="form-control" />
                  </div>
                  <div class="col-md-1 mt-4">
                      <b-button variant="danger" @click="deleteRow(index)"><i class="fas fa-trash"></i></b-button>
                  </div>
                  </div>
              </div>
              </form>
          </tab-content>
          <tab-content title="Class Information" icon="mdi mdi-school">
              <div class="row">
              <b-form-group class="col-md-3 mb-1" label="Class">
                <multiselect v-model="schoolclass" label="name" :options="schoolclasses"></multiselect>
              </b-form-group>
              <b-form-group class="col-md-3 mb-1" label="Term">
                <multiselect v-model="schoolterm" label="name" :options="schoolterms"></multiselect>
              </b-form-group>
              <b-form-group class="col-md-3 mb-1" label="Admission Year">
                <multiselect v-model="year" :options="years"></multiselect>
              </b-form-group>
              <div class="col-md-3 mb-1">
                <label>Residential Status</label>
                <select class="form-control" v-model="residentialstatus">
                  <option value="Day">Day</option>
                  <option value="Boarding">Boarding</option>
                </select>
              </div>
              </div>
          </tab-content>
        </form-wizard>
      </div>
    </div>
  </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import Multiselect from "vue-multiselect";
  import { countriesMethods, countriesComputed, schoolclassMethods, schoolclassComputed,  } from "@/state/helpers";
  export default {
    page: {
      title: "Application ",
      meta: [{name: "description",content: appConfig.description}],
    },
    components: { Layout,Multiselect,FormWizard,TabContent },
    data() {
      return {
      userData: JSON.parse(localStorage.getItem("user")),
      token: localStorage.getItem("token"),
      options : { weekday: "long", year: "numeric", month: "long", day: "numeric",},
      currentdate:new Date().toLocaleDateString('fr-CA'),
      admissionnumber:'', studentname:'', nationality:'Uganda', telephone:'', gender:'Male', address:'',
      dob:new Date().toLocaleDateString('fr-CA'), 
      reg_date:new Date().toLocaleDateString('fr-CA'),
      parents: [],
      schoolterms: [{id:1, name: 'Term 1'},{id:2, name: 'Term 2'}, {id:3, name: 'Term 3'}], schoolterm:'',
      schoolclass:'', year:new Date().getFullYear(),
      residentialstatus:'Day', previousschool:'', religion:'Christian',
      loader:false,
      };
    },
    created() {
      this.fetchCountries();
      this.nationality = this.countries.find(option => option.name = 'Uganda');
      this.fetchSchoolClasses();
    },
    mounted(){
        this.nationality = this.countries.find(option => option.name == 'Uganda');
    },
    computed: {
    ...countriesComputed,
    ...schoolclassComputed,
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
      return yearArray;
    },
    },
    methods: {
      ...countriesMethods,
      ...schoolclassMethods,
       async onComplete() { 
      this.loader=true;
        let obj = {
            studentname:this.studentname,
            gender:this.gender,
            telephone:this.telephone,
            date_of_birth:this.dob,
            nationality:this.nationality,
            address:this.address,
            previousschool:this.previousschool,
            religion:this.religion,
            reg_date:this.reg_date,
            parents:this.parents, 
            schoolterm:this.schoolterm.id,
            year:this.year,
            schoolclass:this.schoolclass.id,
            residentialstatus:this.residentialstatus,
        }
        let url = "/admitstudent";
        await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
            // this.$swal({ title:'Success', text:response.data.message, icon:'success'});
            this.$router.push({name: "success", query: { admissionnumber: response.data.admissionnumber, name:this.studentname }})
           }
         });
        },
        AddformData() {
            this.parents.push({ name: "", gender: "", telephone: "", address: "" });
        },
        deleteRow(index) {
        if (confirm("Are you sure you want to delete this Guardian?"))
            this.parents.splice(index, 1);
        },
    },
  };
  </script>